export default {
ourLovelyTeam: "Our Lovely Team",
meetOurTeamTitle: "Meet Our Kind Friends",
meetOurTeamDescription: "People who make the world of children's learning more beautiful with love and smiles.",
previousSlide: "Previous Slide",
nextSlide: "Next Slide",
goToSlide: "Go to slide",

};
